const HeaderData = [
  {
    id: "sluzby-menu-item",
    title: "Služby",
    link: "/#services",
    className: "menu-item-link",
    megamenuClassName: "services-megamenu",
    onClick: () => {
      const sectionId = "services";
      if (window.location.pathname !== "/") {
        // Store the section ID in sessionStorage before navigation
        sessionStorage.setItem("scrollToSection", sectionId);
        window.location.href = "/"; // Navigate to homepage without hash
        return;
      }
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    },
    megamenu: [
      {
        title: "Expertíza",
        dropdown: [
          {
            title: "Obsahová stratégia",
            isClickable: false,
          },
          {
            title: "Výkonnostná analytika",
            isClickable: false,
          },
          {
            title: "Brand komunikácia",
            isClickable: false,
          },
          {
            title: "AI automatizácia",
            isClickable: false,
          },
          {
            title: "Lead generovanie",
            isClickable: false,
          },
          {
            title: "Kreatíva pre retail",
            isClickable: false,
          },
        ],
      },
      {
        title: "Špecializácia",
        dropdown: [
          {
            title: "Veľkoobchod",
            link: "/#services",

            hoverImage: "/assets/img/webp/velkoobchod.webp", // Add image path
          },
          {
            title: "OTC liečivá",
            link: "/#services",

            hoverImage: "/assets/img/webp/otc-lieciva.webp", // Add image path
          },
          {
            title: "Stavebníctvo",
            link: "/marketing-pre-stavebnictvo",

            hoverImage: "/assets/img/webp/stavebnictvo.webp", // Add image path
          },
          {
            title: "Podlahové štúdiá",
            link: "/marketing-pre-podlahy",
            hoverImage: "/assets/img/webp/podlahove-studia.webp", // Add image path
            onClick: () => {
              // Direct navigation without any scrolling or storage
              window.open("/marketing-pre-podlahy", "_blank");
            },
          },
          {
            title: "Market entry SK/CZ",
            link: "/#services",

            hoverImage: "/assets/img/webp/market-entry.webp", // Add image path
          },
          {
            title: "Váš segment?",
            link: "#",
            modalAction: "openContactModal", // Add a custom action indicator instead of a link
            hoverImage: "/assets/img/webp/vas-segment.webp", // Keep the image path
          },
        ],
        // Default image when no item is hovered
        defaultImage: "/assets/img/webp/default-specialty.webp",
      },
    ],
  },

  {
    id: "blog-menu-item",
    title: "Blog",
    link: "/blog",
    className: "menu-item-link",
  },
  {
    id: "pricelist-menu-item",
    title: "Cenník",
    link: "/#pricelist",
    className: "menu-item-link",
    onClick: () => {
      const sectionId = "pricelist";
      if (window.location.pathname !== "/") {
        // Store the section ID in sessionStorage before navigation
        sessionStorage.setItem("scrollToSection", sectionId);
        window.location.href = "/"; // Navigate to homepage without hash
        return;
      }
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    },
  },
  {
    id: "kariera-menu-item",
    className: "menu-item-link",
    title: "kariéra",
    notification: {
      count: 1,
      animate: true,
    },
    link: "/#careers",
    onClick: () => {
      const sectionId = "careers";
      if (window.location.pathname !== "/") {
        // Store the section ID in sessionStorage before navigation
        sessionStorage.setItem("scrollToSection", sectionId);
        window.location.href = "/"; // Note: Don't include the hash here
        return;
      }
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    },
  },
  {
    id: "newsletter-menu-item",
    title: "Newsletter",
    className: "menu-item-link",
    link: "/#newsletter",
    onClick: () => {
      const sectionId = "newsletter";
      if (window.location.pathname !== "/") {
        // Store the section ID in sessionStorage before navigation
        sessionStorage.setItem("scrollToSection", sectionId);
        window.location.href = "/"; // Note: Don't include the hash here
        return;
      }
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    },
    megamenu: [
      {
        title: "B2B² newsletter",
        dropdown: [
          {
            title:
              "Exkluzívny výber najzaujímavejšieho diania z B2B marketingu. Novinky v propagácii, behaviorálne chovanie, rozhodovacie procesy a praktické tipy pre obchodnú stratégiu.",
            link: "/#newsletter",
            scrollTo: "newsletter",
          },
        ],
      },
      {
        dropdown: [
          {
            link: "/#newsletter",
            img: "/assets/img/webp/b2b2_newsletter_promo.webp",
            alt: "B2B² newsletter",
            scrollTo: "newsletter",
            onClick: () => {
              const sectionId = "newsletter";
              if (window.location.pathname !== "/") {
                // Store the section ID in sessionStorage before navigation
                sessionStorage.setItem("scrollToSection", sectionId);
                window.location.href = "/"; // Navigate to homepage without hash
                return;
              }
              const element = document.getElementById(sectionId);
              element?.scrollIntoView({ behavior: "smooth" });
            },
            className: "newsletter-image-link", // Add a class for styling
          },
        ],
      },
    ],
  },
  {
    id: "contact-menu-item",
    title: "Kontakt",
    className: "menu-item-link",
    link: "/#contact",
    onClick: () => {
      const sectionId = "contact";
      if (window.location.pathname !== "/") {
        // Store the section ID in sessionStorage before navigation
        sessionStorage.setItem("scrollToSection", sectionId);
        window.location.href = "/"; // Navigate to homepage without hash
        return;
      }
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    },
  },
];

export default HeaderData;
